export const FirebaseConfig = {
  projectId: "haraka-ride",
  appId: "1:657479360383:web:7f558b8fb1e7a82ed0c44a",
  databaseURL: "https://haraka-ride-default-rtdb.firebaseio.com",
  storageBucket: "haraka-ride.firebasestorage.app",
  apiKey: "AIzaSyCstUQqAjxk2Mx37bcIuu4yASxTLXS8wXQ",
  authDomain: "haraka-ride.firebaseapp.com",
  messagingSenderId: "657479360383",
};


